export default "__VITE_ASSET__fgiqL1cS__"